import React, { useState, useEffect, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { store } from '../../store'



const ProposalWIP = (props) => {

	const globalState = useContext(store);
	const { dispatch } = globalState;
	let history = useHistory()


  const [ proposalList, setProposalList] = useState([])

	const fetchData = async () => {

	  const response = await fetch('/api/v1/wip_index', {
	    headers: {
	      'Content-Type': 'application/json',
	      'Authorization': globalState.state.Authentication
	    },
	    method: 'get'
	  })
	  const responseJson = await response.json()
	  

	  if (response.ok) {
	    setProposalList(responseJson)
	  } else {
	    alert.show("Server is down.")
	    return false
	  }	
	}

	useEffect( () => {
	  fetchData();
	}, []);

	

	const proposal_list = proposalList.map( propsal => {		
		return (
    	<tr key={propsal.id}>
	      <td><Link className="link" to={{pathname:"/proposal-preview", state:{ project_details_id: propsal.project_detail.id, proposal_id:propsal.id}}}  >{propsal.project_detail.title}</Link></td>
	      <td>{propsal.project_detail.company_name}</td>
	      <td>{propsal.project_detail.creator}</td>
	      <td>{propsal.project_detail.update_date}</td>
	      <td>{propsal.project_detail.proposal_due_date_dv}</td>
	      <td><Link className="link" to={{pathname:"/edit-proposal", state:{ project_details_id: propsal.project_detail.id, proposal_id:propsal.id}}}  >Edit</Link></td>
	    </tr>
  	)		

  })

  return (
    <div className="container">
      <div className="row g-2 align-items-center">
        <div className="col-md text-start">
          <h2 className="card-title page-title my-3"><FontAwesomeIcon icon="bookmark" /> Proposals WIP</h2>
        </div>
    	</div>
    	<div className="col-md mt-4">
    		<table className="table table-bordered table-striped table-sm text-start">
				  <thead>
				    <tr>
				      <th scope="col">Project Title</th>
				      <th scope="col">Company</th>
				      <th scope="col">Posted by</th>
				      <th scope="col">Date Posted</th>
				      <th scope="col">Submission Deadline</th>				      
				      <th scope="col"></th>				      
				    </tr>
				  </thead>
				  <tbody>
			    	{proposal_list}
				  </tbody>
				</table>

    	</div>
    </div>
  );
}

export default ProposalWIP;
